import { createUserWithEmailAndPassword, getAuth, sendEmailVerification, updateProfile } from 'firebase/auth';
import React, {useContext, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import app from '../../firebase.init';

const Register = () => {
    let {setUser, setExist, exist} = useContext(UserContext)
    let navigate = useNavigate();
    let auth = getAuth(app);

    useEffect(()=>{
        if(exist === true)
            navigate('/user');
    },[exist, navigate])

    let submitForm = (e) => {
        e.preventDefault();
        console.log(e.target.email);
        let email = e.target.email.value;
        let name = e.target.name.value;
        let password = e.target.password.value;


        createUserWithEmailAndPassword(auth, email, password, name)
            .then((userCredential) => {
                const user = userCredential.user;
                setUser(user);
                setExist(true);
                updateProfile(auth.currentUser, {
                    displayName: name
                  })
                  .then(() => {
                  }).catch((error) => {
                    alert(error);
                  });
                sendEmailVerification(auth.currentUser)
                  .then(() => {
                  });
                e.target.reset();
            })
            .catch((error) => {
                e.target.reset();
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(errorCode, errorMessage);
            });
    }

    return (
        <div className='max-w-xl px-4 mx-auto my-20'>
            <h1 className='text-3xl mt-5 text-success '>Please Register</h1>
            <form className='text-left my-10' onSubmit ={submitForm} >
                <h1 className='text-xl text-primary'>Name</h1>
                <input type="text" name='name' placeholder="Name" className="input input-bordered input-secondary w-full my-5" />

                <h1 className='text-xl text-primary'>Email</h1>
                <input type="text" name='email' placeholder="Email" className="input input-bordered input-secondary w-full my-5" />

                <h1 className='text-xl text-primary'>Password</h1>
                <input type="password" name='password' placeholder="Password" className="input input-bordered input-secondary w-full my-5" />
                <div className='mx-auto flex justify-between'>
                    <button type='submit' className='btn btn-success mt-5 px-10'>Register</button>
                    <Link to='/login'>
                    <button className='btn btn-primary mt-5 px-10'>Old User?</button>
                    </Link>
                </div>
            </form>

            
        </div>
    );
};

export default Register;